import { Api } from '@/api/api.client';
import { ApiError } from '@/api/api.error';
import type { Components } from '@/api/generated/api';
import { ErrorTypes } from '@/api/generated/api.enum';
import { attribution } from '@/services/attribution';

export async function fetchWhoAmI(): Promise<Components.Schemas.WhoAmIDataDto> {
  const res = await Api.Routes.Auth.whoAmI();
  return res.data;
}

/** The persisted csrf token outlives the session cookie, so only the server can tell whether it still belongs to a session. */
export async function isSessionExpired(): Promise<boolean> {
  try {
    await fetchWhoAmI();
    return false;
  } catch (error) {
    return error instanceof ApiError && error.getErrorType() === ErrorTypes.INVALID_TOKEN;
  }
}

/** Adds the browser attribution snapshot, so every email registration carries it. */
export async function registerWithEmail(
  dto: Omit<Components.Schemas.LocalLoginRegisterDto, 'attribution'>,
): Promise<void> {
  await Api.Routes.Auth.register({}, { ...dto, attribution: attribution.read() });
}

export async function savePendingSsoAttribution(authAttempt: Components.Schemas.AuthAttemptDto): Promise<void> {
  const snapshot = attribution.read();
  if (snapshot == null) return;

  await Api.Routes.Attribution.savePendingSsoAttribution(
    { authAttemptId: authAttempt.id },
    { secret: authAttempt.secret, attribution: snapshot },
  );
}

export async function switchUserRole(userRoleId: number): Promise<void> {
  await Api.Routes.Auth.changeUserRole({}, { userRoleId });
}

export async function fetchSsoProviders(): Promise<Components.Schemas.SsoAuthProviderDto[]> {
  const res = await Api.Routes.Auth.retrieveSsoProviders({});
  return res.data;
}
